import React from "react";
import { LoginStyles } from "./Login.styled";
import rewardScreen from "../../images/cashbach/Bankscreen-Rewards.png";
import { useHistory } from "react-router-dom";
const Reward = () => {
  const history = useHistory();

  return (
    <LoginStyles>
      <div className="images-section-div">
        <img src={rewardScreen} alt="login-screen" className="login-screen" />
        <button
          className="transparent-btn-r"
          aria-label="Click"
          onClick={() => {
            history.push("/cardpage");
          }}
        > 
        </button>
      </div>
    </LoginStyles>
  );
};
export default Reward;
